import { Inject } from '@rxdi/core';
import { Component, css, html, LitElement } from '@rxdi/lit-html';
import { ScrollToService } from '@shared/services';
import { SteelFabTheme } from '@shared/styles/theme';

import { CategoriesComponent } from './categories/categories.component';
import { ContactComponent } from './contact/contact.component';
import { FeaturedProductsComponent } from './featured-products/featured-products.component';
import { HeroComponent } from './hero/hero.component';
import { PartnersComponent } from './partners/partners.component';

/**
 * @customElement home-component
 */
@Component({
  selector: 'home-component',
  components: [HeroComponent, CategoriesComponent, FeaturedProductsComponent, PartnersComponent, ContactComponent],
  styles: [
    css`
      ${SteelFabTheme}

      :host {
        display: block;
      }
    `,
  ],
  template() {
    return html`
      <hero-component></hero-component>
      <categories-component></categories-component>
      <featured-products-component></featured-products-component>
      <partners-component></partners-component>
      <contact-component></contact-component>
    `;
  },
})
export class HomeComponent extends LitElement {
  @Inject(ScrollToService)
  private scrollToService: ScrollToService;

  OnUpdateFirst() {
    this.scrollToService.setElements(Array.from(this.shadowRoot.querySelectorAll('*')) as HTMLElement[]);
  }
}
